<template>
    <div v-if="info && canShow('中医体质辨识（商业版）') && info.tizhi_text_array && info.tizhi_qingxiang_text_array">
        <div class="tips"></div>
        <div class="sick-box">
            <div class="risk">中医体质辨识</div>
        </div>
        <div class="assessment">
            <div class="new-title">您当前的中医体质</div>
            <div class="sick-list flex flex-w">
                <div v-for="(item, index) in info.tizhi_text_array" :key="'main20-' + index" >
                    <div class="new-sick tiz-sick">
                        {{ item }}<span>(主)</span>
                    </div>
                </div>
                <div  v-for="(item, index) in info.tizhi_qingxiang_text_array" :key="'phy20-' + index">
                    <div class="new-sick tiz-sick" v-if="item">
                        {{ item }}<span>(兼)</span>
                    </div>
                </div>
            </div>

            <div class="business-analysis-box" v-if="info.jibing.tiaoli">
                <div class="business-analysis-title">健康状态分析</div>
                <div class="business-analysis-desc">
                    {{ info.jibing.fenxi }}
                </div>
            </div>

            <div class="table-mark" v-if="info.jibing.jibing">
                <table class="newre-table business-table">
                    <thead>
                        <tr>
                            <th style="width: 24%;">影响系统</th>
                            <th style="width: 38%;">易感疾病</th>
                            <th style="width: 38%;">体质原因</th>
                        </tr>  
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in info.jibing.jibing" :key="'jibing-' + index">
                            <td class="bold-text">{{ item.sysName }}</td>
                            <td class="left-align-text">{{ item.sd }}</td>
                            <td class="left-align-text">{{ item.cp }}</td>
                        </tr>
                    </tbody>  
                </table>
            </div>

        </div>
    </div>
</template>
<script>
import { moduleMixin } from '../helpers';
import { mapState } from 'vuex';
export default {
    name: 'ReportPhysiqueBusiness',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info'])
    },
};
</script>
<style lang="scss" scoped>
@import './PhysiqueBusiness.scss';
</style>
